import axios from 'axios'
import * as restfulService from './restfulService'
import bus from '@utils/bus'

export default {
  get (domains) {
    // Lista de requisições que serão executadas
    const promises = []
    // Lista de respostas das requisições
    const responses = {}

    if (domains !== undefined && domains.length > 0) {
      bus.$emit('show-loader')
      // Percorre a lista de domains solicitada
      domains.forEach(function (val) {
        if (val !== undefined) {
          val.route = val.route || null
          let defaultData = {
            orderBy: [
              {
                column: 'name',
                direction: 'ASC'
              }
            ]
          }
          let data = val.data || defaultData
          switch (val.domain) {

            case 'role':
              promises.push(restfulService.search('role', val.route, data, null, null, 1, 2000))
              responses.roles = []
              break

            case 'permission':
              promises.push(restfulService.search('permission', val.route, data, null, null, 1, 2000))
              responses.permissions = []
              break

            case 'country':
              data = null
              promises.push(restfulService.get('country', val.route, data, null, null, 1, 2000))
              responses.countries = []
              break

            case 'state':
              data = null
              promises.push(restfulService.get('state', val.route, data, null, null, 1, 2000))
              responses.states = []
              break

            case 'city':
              data = null
              promises.push(restfulService.get('city', val.route, data, null, null, 1, 100))
              responses.cities = []
              break

            case 'knowledge_area':
              data = {
                knowledge_area_id: null,
                orderBy: [
                  {
                    column: 'name',
                    direction: 'ASC'
                  }
                ]
              }
              promises.push(restfulService.search('knowledge_area', val.route, data, null, null, 1, 2000))
              responses.knowledge_areas = []
              break

            case 'institution_unit':
              promises.push(restfulService.search('institution_unit', val.route, data, null, ['institution'], 1, 2000))
              responses.institution_units = []
              break

            case 'modality':
              promises.push(restfulService.search('modality', val.route, data, null, null, 1, 2000))
              responses.modalities = []
              break

            case 'literacy':
              promises.push(restfulService.search('literacy', val.route, data, null, null, 1, 2000))
              responses.literacies = []
              break

            case 'place':
              data = {
                orderBy: [
                  {
                    column: 'description',
                    direction: 'ASC'
                  }
                ]
              }
              promises.push(restfulService.search('place', val.route, data, null, null, 1, 2000))
              responses.places = []
              break

            case 'event':
              data = {
                orderBy: [
                  {
                    column: 'title',
                    direction: 'ASC'
                  }
                ]
              }
              promises.push(restfulService.search('event', val.route, data, null, null, 1, 2000))
              responses.events = []
              break

            case 'main_event':
              data = {
                event_id: null,
                orderBy: [
                  {
                    column: 'title',
                    direction: 'ASC'
                  }
                ]
              }
              promises.push(restfulService.search('event', val.route, data, null, null, 1, 2000))
              responses.main_events = []
              break

            case 'public_paper_status':
              promises.push(restfulService.get('paper_status', 'public'))
              responses.public_paper_status = []
              break

            case 'registration_status':
              promises.push(restfulService.search('registration_status', val.route, data, null, null, 1, 2000))
              responses.registration_status = []
              break

            case 'marital_status':
              promises.push(restfulService.get('marital_status'))
              responses.marital_status = []
              break

            case 'special_needs':
              promises.push(restfulService.get('special_needs'))
              responses.special_needs = []
              break

            case 'ethnicity':
              promises.push(restfulService.get('ethnicity'))
              responses.ethnicities = []
              break

            case 'evaluation_type':
              promises.push(restfulService.get('evaluation_type'))
              responses.evaluation_types = []
              break

          }
        }
      })
    }

    let loopCounter = 0

    /**
     * Realiza todas as requisições e atribui os resultados ao objeto respose
     * @type {Promise<any>}
     */
    const data = axios.all(promises)
      .then((result) => {
        for (let index in responses) {
          if (result[loopCounter] !== undefined) {
            if (result[loopCounter].data !== undefined) {
              responses[index] = result[loopCounter].data
            } else {
              responses[index] = result[loopCounter]
            }
          } else {
            responses[index] = []
          }
          loopCounter++
        }
        return responses
      })

    /**
     * Retorna uma nova Promisse com o resultado das requisições
     * Exemplo de retorno:
     * {
     *      clients: [],
     *      products: []
     *  }
     */
    return new Promise((resolve) => {
      resolve(data)
      bus.$emit('hide-loader')
    })
  }
}
